/*
  DENIMFY – Farbwechsel mit automatischer Größenwahl
  Wird eine Farbe angeklickt, die es in der gewählten Größe nicht gibt oder
  die in dieser Größe ausverkauft ist, wird automatisch die erste verfügbare
  Größe dieser Farbe (Reihenfolge wie im Dropdown) ausgewählt.
  Bei Artikeln mit weiterem Dropdown (z. B. Packgröße) bleibt zuerst die Größe,
  dann das weitere Feld nach Möglichkeit erhalten.
  Ist die gewählte Größe in der neuen Farbe verfügbar, bleibt sie stehen.
  Gibt es die Farbe in keiner Größe mehr, wird die erste vorhandene Größe gewählt.
*/
(function () {
  if (window.__dfFarbwechselGroesse) return;
  window.__dfFarbwechselGroesse = true;

  function selectedValues(fieldsets) {
    return fieldsets.map(function (fs) {
      var select = fs.querySelector('select');
      if (select) return select.value;
      var checked = fs.querySelector('input:checked');
      return checked ? checked.value : null;
    });
  }

  function matches(variant, values) {
    return values.every(function (val, i) {
      return val === null || variant.options[i] === val;
    });
  }

  document.addEventListener('change', function (event) {
    var input = event.target;
    if (!input || input.tagName !== 'INPUT' || input.type !== 'radio') return;

    var picker = input.closest('variant-selects');
    if (!picker || typeof picker.getVariantData !== 'function') return;

    var fieldsets = Array.prototype.slice.call(picker.querySelectorAll('fieldset'));
    var changedIndex = fieldsets.indexOf(input.closest('fieldset'));
    if (changedIndex < 0) return;

    var variants = picker.getVariantData();
    if (!variants || !variants.length) return;

    var current = selectedValues(fieldsets);
    var exact = variants.find(function (v) { return matches(v, current); });
    var target = exact;

    if (!exact || !exact.available) {
      // Dropdown-Felder (z. B. Größe), die angepasst werden dürfen
      var dropdownIndexes = [];
      fieldsets.forEach(function (fs, i) {
        if (i !== changedIndex && fs.querySelector('select')) dropdownIndexes.push(i);
      });

      if (dropdownIndexes.length) {
        var fixed = current.map(function (val, i) {
          return dropdownIndexes.indexOf(i) >= 0 ? null : val;
        });
        var candidates = variants.filter(function (v) { return matches(v, fixed); });

        var positions = dropdownIndexes.map(function (i) {
          return Array.prototype.map.call(fieldsets[i].querySelectorAll('select option'), function (o) { return o.value; });
        });
        // Reihenfolge: bisherige Auswahl möglichst behalten (erst Größe, dann weitere Felder),
        // danach die Reihenfolge im Dropdown
        var sortKey = function (v) {
          var keep = dropdownIndexes.map(function (i) {
            return v.options[i] === current[i] ? 0 : 1;
          });
          var order = dropdownIndexes.map(function (i, k) {
            var p = positions[k].indexOf(v.options[i]);
            return p < 0 ? 9999 : p;
          });
          return keep.concat(order);
        };
        candidates.sort(function (a, b) {
          var ka = sortKey(a), kb = sortKey(b);
          for (var k = 0; k < ka.length; k++) {
            if (ka[k] !== kb[k]) return ka[k] - kb[k];
          }
          return 0;
        });

        var firstAvailable = candidates.find(function (v) { return v.available; });
        if (firstAvailable) {
          target = firstAvailable;
        } else if (!exact && candidates.length) {
          target = candidates[0];
        }

        if (target && target !== exact) {
          dropdownIndexes.forEach(function (i) {
            fieldsets[i].querySelector('select').value = target.options[i];
          });
        }
      }
    }

    // Variante am zuletzt gewählten Feld korrekt hinterlegen (sonst bleibt die ID der vorherigen Farbe stehen)
    if (target) {
      var lastFieldset = fieldsets[fieldsets.length - 1];
      var lastSelected = lastFieldset.querySelector('select option:checked') || lastFieldset.querySelector('input:checked');
      if (lastSelected) lastSelected.setAttribute('variant_id', target.id);
    }
  }, true);
})();
